module.exports = __webpack_public_path__ + "img/info-circle.3978c615.svg";